// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");

function make(priceType, price, minPrice, maxPrice) {
  if (priceType === "ExactPrice") {
    if (price !== undefined) {
      return {
        TAG: "Ok",
        _0: {
          exactPrice: {
            price: Primitive_option.valFromOption(price)
          }
        }
      };
    } else {
      return {
        TAG: "Error",
        _0: "error making propertyPriceInput"
      };
    }
  } else if (minPrice !== undefined && maxPrice !== undefined) {
    return {
      TAG: "Ok",
      _0: {
        priceRange: {
          maxPrice: Primitive_option.valFromOption(maxPrice),
          minPrice: Primitive_option.valFromOption(minPrice)
        }
      }
    };
  } else {
    return {
      TAG: "Error",
      _0: "error making propertyPriceInput"
    };
  }
}

let Schema;

exports.Schema = Schema;
exports.make = make;
/* No side effect */
